import React, { Component } from 'react'
import NewsImage from './Image/NewsImage';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

class CheckNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: []
        }
    }

    componentDidMount(){
        let url = "http://192.168.43.229:5001/news";
        fetch(url,{
            headers: new Headers({
                'Origin': 'self'
            })
        }
            ).then((resp) => resp.json())
        .then((data)=>{
            console.log(data[0]);
            this.setState({
                news: data[0]
            })
        })
    }

    createMarkup(value){
        return { __html: value };
    }
    
  render() {
      let subCom = [];
      subCom[0] = this.state.news; 
      subCom[1] = this.createMarkup(subCom[0].message);
      console.log(subCom[1].__html);
      const string = `<NewsImage path="uploads"/>`;
    return (
          
      <div>
        {this.state.news.title}<br/>
            {this.state.news.message}
      </div>
    )
  }
}

export default CheckNews;



// WEBPACK FOOTER //
// ./src/HomeComponents/CheckNews.js